import React from "react";
import styles from "./styles.module.css";
const CategoryCard = ({ category }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardImage}>
        <img src={category?.image} alt={category?.name} />
      </div>
      <div className={styles.text}>
        <h4>{category?.title}</h4>
        <p>{category?.posts?.length} POSTS</p>
      </div>
    </div>
  );
};

export default CategoryCard;
